import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Tabs } from '@teamsnap/teamsnap-ui';

import { MessageList } from '../messages';

export interface Props extends RouteComponentProps<any> {}

const Messages: React.FunctionComponent<Props> = ({
  match: {
    params: { orgId },
  },
}) => (
  <div id="messages" className="container hub-full-width">
    <div className="page-content u-xs-padXl u-flexExpandSides">
      <div className="page-content-header Grid u-flexAlignItemsCenter">
        <div className="Grid-cell u-xs-size1of2">
          <h1>Messages</h1>
        </div>
        <div className="Grid-cell u-xs-size1of2 u-textRight button-list">
          <Link to={`/organizations/${orgId}/messages/new`}>
            <Button color="primary" icon="plus" iconPosition="left">
              New Email
            </Button>
          </Link>
        </div>
      </div>
      <div className="page-content-body">
        <Tabs tabs={[{
          heading: 'Sent',
          content: (<MessageList orgId={+orgId} />)
        }]}
        />
      </div>
    </div>
  </div>
);

export default Messages;
